import { AutorisationAggregate } from '../../../../../aggregats/autorisation/autorisation.aggregate';
import { AutorisationsAggregate } from '../../../../../aggregats/autorisation/autorisations.aggregate';
import { SousMenuItemAggregate } from '../../../../../aggregats/menu/sous-menu-item.aggregate';
import { FonctionLogicielle } from '../../../../fonctions-logicielle-constantes';
import { EparcoursPath } from '../../eparcours-path';

export const dossiersFinancementSousMenuItem = new SousMenuItemAggregate(
  `Contrats`,
  `/${EparcoursPath.root.DOSSIERS_FINANCEMENT}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.FinancementInscriptions)]),
);

export const facturationSousMenuItemSuivi = new SousMenuItemAggregate(
  'Suivi des factures',
  `/${EparcoursPath.root.FACTURATION}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.Facturation)]),
);

export const facturationSousMenuItemTraitement = new SousMenuItemAggregate(
  'Génération de factures',
  `/${EparcoursPath.root.FACTURATION_TRAITEMENT}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.Facturation)]),
);

export const exportComptableSousMenuItem = new SousMenuItemAggregate(
  `Comptabilité`,
  `/${EparcoursPath.root.COMPTABILITE}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.ExportComptable)]),
);
